import React from "react";
import { Button, Input, Stack } from "@altimateai/lego";

interface DateFiltersProps {
  startDate: string;
  endDate: string;
  selectedPreset: number | null;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onPresetSelect: (days: number) => void;
  onRefresh: () => void;
}

export const DateFilters: React.FC<DateFiltersProps> = ({
  startDate,
  endDate,
  selectedPreset,
  onStartDateChange,
  onEndDateChange,
  onPresetSelect,
  onRefresh,
}) => {
  return (
    <Stack direction="row" align="center" justify="end" gap="md" className="al-mb-6 al-flex-wrap">
      <Stack direction="row" align="center" gap="sm">
        <Button
          variant={selectedPreset === 7 ? "default" : "outline"}
          size="sm"
          onClick={() => onPresetSelect(7)}
        >
          Last 7 Days
        </Button>
        <Button
          variant={selectedPreset === 30 ? "default" : "outline"}
          size="sm"
          onClick={() => onPresetSelect(30)}
        >
          Last 30 Days
        </Button>
      </Stack>
      <Stack direction="row" align="center" gap="sm">
        <Input
          type="date"
          value={startDate}
          onChange={e => onStartDateChange(e.target.value)}
          className="al-w-36"
        />
        <span className="al-text-gray-500">to</span>
        <Input
          type="date"
          value={endDate}
          onChange={e => onEndDateChange(e.target.value)}
          className="al-w-36"
        />
      </Stack>
      <Button variant="ghost" size="sm" onClick={onRefresh}>
        Refresh
      </Button>
    </Stack>
  );
};
